import { AccountResponse } from './billing-engine-queries'

export function isAccountLoadedAndCustomerShouldPay(account?: AccountResponse) {
  return !!account && account.client.paymentAvailable
}

export function isAccountLoadedAndCustomerPaid(account?: AccountResponse) {
  return !!account && !account.plan.isBase
}

export function isAccountLoadedAndCustomerPaidOrUnlimited(
  account?: AccountResponse,
) {
  return !!account && (!account.plan.isBase || account.plan.isUnlimited)
}
